import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { AvailableTabProperties } from '../../../../interface/device-management.interface';
import { useAppDispatch } from '../../../../redux/hooks';
import { setPageTitle } from '../../../../redux/slices/PageTitleSlice';
import DeviceDetails from '../../../charger-pages/advanced-charger-management/components/device-details/DeviceDetails';
// import DeviceSearch from '../../../charger-pages/advanced-charger-management/components/DeviceSearch';
import OcppConsole from '../../../charger-pages/advanced-charger-management/components/ocpp-console/OcppConsole';

import DeviceHubDetailsTabs from './DeviceHubDetailsTabs';

/**
 * Container component for EV Device Hub device details and OCPP console tabs
 * @returns {React.ReactElement} The rendered device hub details container component
 */
function DeviceHubDetailsContainer() {
  const { t } = useTranslation('devices');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { tab: deviceTab, id } = useParams<{ tab: string; id: string }>();
  const [containerTabs, setContainerTabs] = useState<AvailableTabProperties[]>([
    {
      label: t('deviceDetails'),
      key: 'device-details',
      isActive: false,
    },
    {
      label: t('oCPPConsole'),
      key: 'ocpp-console',
      isActive: false,
    },
  ]);

  const { search } = useLocation();

  /**
   * Switches the active tab
   * @param {string} key - The key of the tab to switch to
   * @param {boolean} navigateRequire - Whether to navigate to the new route
   * @returns {void}
   */
  const handleSwitchTab = (key: string, navigateRequire: boolean = true) => {
    setContainerTabs((previousTabs: AvailableTabProperties[]) =>
      previousTabs.map((tab) => {
        if (tab.key === key) {
          if (navigateRequire) {
            navigate({
              pathname: `/ev-admin/ev-device-hub/device-details/${id}/${tab.key}`,
              search,
            });
          }
          return {
            ...tab,
            isActive: true,
          };
        }
        return {
          ...tab,
          isActive: false,
        };
      }),
    );
  };

  useEffect(() => {
    handleSwitchTab(deviceTab || 'device-details', false);
  }, [deviceTab, id]);

  useEffect(() => {
    dispatch(setPageTitle({ title: 'Device Management' }));
  }, [dispatch]);

  return (
    <div className="device-management-wrap">
      <div className="device-management-container">
        <DeviceHubDetailsTabs
          containerTabs={containerTabs}
          handleSwitchTab={handleSwitchTab}
          deviceId={id}>
          {/* <DeviceSearch /> */}
        </DeviceHubDetailsTabs>
        <div className="device-management-content">
          {(() => {
            const activeTab = containerTabs.find((tab) => tab.isActive)?.key || 'device-details';

            let deviceContent = null;
            switch (activeTab) {
              case 'device-details':
                deviceContent = <DeviceDetails />;
                break;
              case 'ocpp-console':
                deviceContent = <OcppConsole />;
                break;
              default:
                deviceContent = <DeviceDetails />;
                break;
            }
            return deviceContent;
          })()}
        </div>
      </div>
    </div>
  );
}

export default DeviceHubDetailsContainer;
